import React from "react";
import { Route, Routes } from "react-router-dom";

import { AllLayout } from "./screen/AllLayout";
import { MainLayout } from "./screen/mainLayout";

import MobileStoreDetails from "./screen/store/storeDetails";

import MobileStoreSelector from "./screen/intro/storeSelector";
import MobileOrderDetails from "./screen/order/orderDetails";
import MobileOrderStatus from "./screen/order/orderStatus";
import MobilePassword from "./screen/payment/password";
import MobilePayment from "./screen/payment/payment";
import MobileMenuDetails from "./screen/store/menu/menuDetails";

import ErrorPage from "./screen/ErrorPage";
import { MobileLogin } from "./screen/MobileLogin";
import MainPage from "./screen/intro/MainPage/MainPage";

const App = () => {
  return (
    <Routes>
      <Route path="/:hotel_id/:area_id/:room_id" element={<MobileLogin />} />
      <Route element={<AllLayout />}>
        <Route element={<MainLayout />}>
          {/* mobile */}
          <Route path="/master" element={<MainPage />} />
          <Route path="/menu" element={<MobileMenuDetails />} />

          <Route path="/payment" element={<MobilePayment />} />
          <Route path="/password" element={<MobilePassword />} />

          {/* DEV */}
          <Route path="/store" element={<MobileStoreDetails />} />
          <Route path="/status" element={<MobileOrderStatus />} />
          <Route path="/order" element={<MobileOrderDetails />} />

          <Route path="/*" element={<ErrorPage />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default App;
